import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div style={{ minHeight: "100vh", display: "grid", gridTemplateColumns: "1fr", placeItems: "center", background: "linear-gradient(180deg,#FBF8F2 0%,#F6F2EA 100%)", padding: "40px 18px" }}>
      <div className="ddp-fade" style={{ width: "min(460px,100%)" }}>
        <Link to="/" style={{ display: "flex", justifyContent: "center", marginBottom: 28 }}><Logo height={54} /></Link>
        <div className="ddp-card" style={{ padding: "clamp(26px,4vw,40px)" }}>
          <h1 className="ddp-serif" style={{ fontSize: 28, color: "var(--burgundy-dark)", margin: "0 0 6px", textAlign: "center" }}>{title}</h1>
          {subtitle && <p style={{ textAlign: "center", color: "var(--muted)", fontSize: 14.5, margin: "0 0 26px", lineHeight: 1.55 }}>{subtitle}</p>}
          {children}
        </div>
        {footer && <div style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: "var(--muted)" }}>{footer}</div>}
      </div>
    </div>
  );
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { refresh } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      const currentUser = await refresh();
      if (!currentUser) throw new Error("No se pudo cargar la sesión.");
      toast.success("Sesión iniciada");
      const stored = typeof window !== "undefined" ? sessionStorage.getItem("ddp_redirect") : null;
      if (stored) sessionStorage.removeItem("ddp_redirect");
      const fallback = currentUser.role === "admin" ? "/admin/asuntos" : "/inicio";
      const requested = stored && stored.startsWith("/") && !stored.startsWith("/acceso") ? stored : fallback;
      const dest = currentUser.role === "firm_user" && currentUser.agreement_accepted === false
        ? "/inicio"
        : requested;
      navigate(dest);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Acceso"
      subtitle="Área privada para despachos del piloto DDP."
      footer={<Link to="/recuperar" style={{ color: "var(--burgundy)", textDecoration: "none", fontWeight: 600 }}>¿Ha olvidado su contraseña?</Link>}
    >
      <form onSubmit={submit} data-testid="login-form">
        <label className="ddp-label">Email profesional</label>
        <input type="email" className="ddp-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
        <label className="ddp-label" style={{ marginTop: 16 }}>Contraseña</label>
        <input type="password" className="ddp-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
        <button type="submit" disabled={loading} data-testid="login-submit" className="ddp-btn ddp-btn-primary" style={{ width: "100%", marginTop: 24 }}>
          {loading ? "Accediendo…" : "Entrar"}
        </button>
      </form>
      <div className="ddp-hr" style={{ margin: "22px 0 16px" }} />
      <p style={{ fontSize: 13, color: "var(--muted)", textAlign: "center", margin: 0, lineHeight: 1.55 }}>
        El acceso es por invitación. ¿Aún no tiene acceso?{" "}
        <Link to="/#acceso" style={{ color: "var(--burgundy)", fontWeight: 600, textDecoration: "none" }}>Solicite acceso al piloto</Link>.
      </p>
    </AuthShell>
  );
}
